/**
 * Cart Progress Bar - Dynamic updates
 * For Pipeline theme cart drawer
 * Modified to only count products from specific vendors
 */

console.log('🛒 Cart Progress Bar script loaded');

theme.CartProgress = (function() {
  var selectors = {
    cartDrawer: '#drawer-cart',
    progressContainer: '.cart-progress-container',
    progressBar: '.cart-progress-fill',
    progressMessage: '.cart-progress-message',
    milestones: '.cart-milestone',
    shippingMilestone: '.cart-shipping',
    giftMilestone: '.cart-gift'
  };
  
  // Flag to prevent recursive updates
  var isUpdating = false;
  
  // Debounce function to prevent multiple rapid updates
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  function CartProgress(container) {
    console.log('🛒 CartProgress initialized for container:', container);
    this.container = container;
    this.cartDrawer = document.querySelector(selectors.cartDrawer);
    this.shippingThreshold = parseInt(container.getAttribute('data-shipping-threshold')) || 19900;
    this.giftThreshold = parseInt(container.getAttribute('data-gift-threshold')) || 9000;
    
    // List of approved vendors to include in calculations (Anfisa only for GWP)
    this.approvedVendors = [
      'Anfisa'
    ];
    
    console.log('🛒 Thresholds configured - Shipping:', this.shippingThreshold, 'Gift:', this.giftThreshold);
    console.log('🛒 Approved vendors:', this.approvedVendors.join(', '));
    
    this.bindEvents();
    
    // Initial update - with slight delay to prevent race conditions
    setTimeout(() => {
      this.fetchCartAndUpdate();
    }, 100);
  }

  CartProgress.prototype = {
    bindEvents: function() {
      console.log('🛒 Binding cart events');
      
      var self = this; // Store reference to 'this' for event handlers
      
      // Pipeline theme specific event names
      var cartEvents = [
        'theme:cart:change',
        'theme:cart:popdown',
        'cart:updated',
        'cart.requestComplete'
      ];
      
      // Create debounced update function
      var debouncedUpdate = debounce(function(event) {
        console.log('🛒 Event triggered (debounced):', event.type);
        self.onCartUpdate(event);
      }, 300);
      
      cartEvents.forEach(function(eventName) {
        console.log('🛒 Adding listener for', eventName);
        document.addEventListener(eventName, debouncedUpdate);
      });
      
      // Also listen for drawer opening
      document.addEventListener('drawerOpen.drawer-cart', function(event) {
        console.log('🛒 Drawer opened');
        self.onCartUpdate(event);
      });
    },

    onCartUpdate: function(evt) {
      console.log('🛒 onCartUpdate called');
      
      // Skip if already updating to prevent recursion
      if (isUpdating) {
        console.log('🛒 Update already in progress, skipping');
        return;
      }
      
      this.fetchCartAndUpdate();
    },

    fetchCartAndUpdate: function() {
      console.log('🛒 fetchCartAndUpdate called');
      
      // Set flag to prevent recursive updates
      isUpdating = true;
      
      var self = this;
      fetch('/cart.js')
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          console.log('🛒 Cart data received:', cart);
          
          // Check if cart is empty
          if (cart.item_count === 0) {
            // Hide the progress bar when cart is empty
            self.hideProgressBar();
          } else {
            // Calculate total price (all items) for shipping threshold
            var totalPrice = cart.total_price;
            
            // Calculate filtered total (only approved vendors) for gift threshold
            var filteredTotal = self.calculateFilteredTotal(cart.items);
            
            console.log('🛒 Total price (all items):', totalPrice);
            console.log('🛒 Filtered total (approved vendors only):', filteredTotal);
            
            // Show and update the progress bar when cart has items
            self.showProgressBar();
            self.updateProgressBar(totalPrice, filteredTotal);
          }
          
          // Release the update lock
          setTimeout(function() {
            isUpdating = false;
          }, 500);
        })
        .catch(function(error) {
          console.error('🛒 Error fetching cart:', error);
          isUpdating = false;
        });
    },
    
    // Method to calculate total price of only approved vendor items
    calculateFilteredTotal: function(items) {
      console.log('🛒 Calculating filtered total for approved vendors');
      
      var filteredTotal = 0;
      
      if (!items || !Array.isArray(items)) {
        console.error('🛒 Invalid cart items data');
        return filteredTotal;
      }
      
      // Loop through each item in cart
      items.forEach(function(item) {
        var vendor = item.vendor;
        var linePrice = item.line_price;
        
        // Check if item's vendor is in the approved list
        if (this.approvedVendors.includes(vendor)) {
          console.log('🛒 Including item in total:', item.title, '- Vendor:', vendor, '- Price:', linePrice);
          filteredTotal += linePrice;
        } else {
          console.log('🛒 Excluding item from total:', item.title, '- Vendor:', vendor, '- Price:', linePrice);
        }
      }, this);
      
      console.log('🛒 Filtered total calculated:', filteredTotal);
      return filteredTotal;
    },
    
    // Method to hide the progress bar
    hideProgressBar: function() {
      console.log('🛒 Hiding progress bar (empty cart)');
      if (this.container) {
        this.container.style.display = 'none';
      }
    },
    
    // Method to show the progress bar
    showProgressBar: function() {
      console.log('🛒 Showing progress bar');
      if (this.container) {
        this.container.style.display = '';
      }
    },

    updateProgressBar: function(totalPrice, filteredTotal) {
      console.log('🛒 updateProgressBar called with totalPrice:', totalPrice, 'filteredTotal:', filteredTotal);
      
      if (!this.container) {
        console.error('🛒 Container not found');
        return;
      }
      
      var progressBar = this.container.querySelector(selectors.progressBar);
      var progressMessage = this.container.querySelector(selectors.progressMessage);
      var shippingMilestone = this.container.querySelector(selectors.shippingMilestone);
      var giftMilestone = this.container.querySelector(selectors.giftMilestone);
      
      console.log('🛒 Elements found:', 
                 'progressBar:', !!progressBar, 
                 'progressMessage:', !!progressMessage,
                 'shippingMilestone:', !!shippingMilestone,
                 'giftMilestone:', !!giftMilestone);
      
      if (!progressBar || !progressMessage) {
        console.error('🛒 Required elements not found');
        return;
      }
      
      // Calculate shipping progress using total cart price (all items)
      var shippingRemaining = Math.max(0, this.shippingThreshold - totalPrice);
      var shippingUnlocked = totalPrice >= this.shippingThreshold;

      // Calculate gift progress using filtered total (approved vendors only)
      var giftRemaining = Math.max(0, this.giftThreshold - filteredTotal);
      var giftUnlocked = filteredTotal >= this.giftThreshold;

      // Determine which goal to show progress toward
      // Use max threshold for the scale
      var maxThreshold = Math.max(this.shippingThreshold, this.giftThreshold);

      // Progress bar shows the furthest point reached considering both metrics
      // For shipping: use totalPrice, for gift: use filteredTotal
      var shippingProgress = (totalPrice / maxThreshold) * 100;
      var giftProgress = (filteredTotal / maxThreshold) * 100;

      // Show the maximum progress achieved across both thresholds
      var overallProgress = Math.min(100, Math.max(shippingProgress, giftProgress));

      console.log('🛒 Progress calculation - Overall progress:', overallProgress,
                 'Shipping progress:', shippingProgress,
                 'Gift progress:', giftProgress,
                 'Max threshold:', maxThreshold,
                 'Shipping remaining:', shippingRemaining,
                 'Gift remaining:', giftRemaining,
                 'Shipping unlocked:', shippingUnlocked,
                 'Gift unlocked:', giftUnlocked);

      // Update the progress bar width based on overall progress
      progressBar.style.width = overallProgress + '%';
      
      // Update milestone positions dynamically
      var shippingPosition = (this.shippingThreshold / maxThreshold) * 100;
      var giftPosition = (this.giftThreshold / maxThreshold) * 100;

      if (shippingMilestone) {
        shippingMilestone.style.left = shippingPosition + '%';

        if (shippingUnlocked) {
          shippingMilestone.classList.add('cart-milestone-reached');
        } else {
          shippingMilestone.classList.remove('cart-milestone-reached');
        }
      }

      if (giftMilestone) {
        giftMilestone.style.left = giftPosition + '%';

        if (giftUnlocked) {
          giftMilestone.classList.add('cart-milestone-reached');
          giftMilestone.classList.remove('not-qualified');
        } else {
          giftMilestone.classList.remove('cart-milestone-reached');

          // Add 'not-qualified' class if cart total passes gift threshold but filtered total doesn't
          // This shows a red X when they have enough in cart total but not enough Anfisa products
          if (totalPrice >= this.giftThreshold && filteredTotal < this.giftThreshold) {
            giftMilestone.classList.add('not-qualified');
          } else {
            giftMilestone.classList.remove('not-qualified');
          }
        }
      }

      console.log('🛒 Milestone positions - Shipping:', shippingPosition + '%', 'Gift:', giftPosition + '%');
      
      // Update the message
      if (progressMessage) {
        var messageHTML = '';

        if (giftUnlocked && shippingUnlocked) {
          messageHTML = '<p>🎉 <strong>Congratulations!</strong> You\'ve unlocked free shipping and a FREE Ân-Gloss Original!</p>';
        } else if (giftUnlocked) {
          var formattedShippingRemaining = this.formatMoney(shippingRemaining);
          messageHTML = '<p>🎉 <strong>FREE Ân-Gloss Original unlocked!</strong> Add <span class="money">' + formattedShippingRemaining + '</span> more for free shipping</p>';
        } else if (shippingUnlocked) {
          var formattedGiftRemaining = this.formatMoney(giftRemaining);
          messageHTML = '<p>🚚 <strong>Free shipping unlocked!</strong> Add <span class="money">' + formattedGiftRemaining + '</span> more in Anfisa products for a FREE Ân-Gloss Original</p>';
        } else if (this.giftThreshold < this.shippingThreshold) {
          var formattedGiftRemaining = this.formatMoney(giftRemaining);
          messageHTML = '<p>Add <span class="money">' + formattedGiftRemaining + '</span> more <strong>in Anfisa products</strong> for a FREE Ân-Gloss Original</p>';
        } else {
          var formattedShippingRemaining = this.formatMoney(shippingRemaining);
          messageHTML = '<p>Add <span class="money">' + formattedShippingRemaining + '</span> more for free shipping</p>';
        }

        progressMessage.innerHTML = messageHTML;
        console.log('🛒 Message updated');
      }
    },
    
    // Format money helper function
    formatMoney: function(cents) {
      if (typeof theme.Currency !== 'undefined' && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      } else if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      } else {
        // Fallback format
        var value = cents / 100;
        return '$' + value.toFixed(2);
      }
    }
  };

  return CartProgress;
})();

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('🛒 DOMContentLoaded event - initializing progress bars');
  var progressContainers = document.querySelectorAll('.cart-progress-container');
  console.log('🛒 Found', progressContainers.length, 'containers');
  
  progressContainers.forEach(function(container) {
    new theme.CartProgress(container);
  });
});

// Re-initialize when sections load
document.addEventListener('shopify:section:load', function(event) {
  console.log('🛒 shopify:section:load event');
  var progressContainers = event.target.querySelectorAll('.cart-progress-container');
  
  progressContainers.forEach(function(container) {
    new theme.CartProgress(container);
  });
});

console.log('🛒 Cart Progress script execution complete');